<template>
    <div id="app"
         :style="{fontFamily: $store.getters.getLangValue('font_family')}">
        <div v-if="initStatus === 'loading'" class="app-status-wrap">
            <div class="app-status-card">
                <h2>Loading event page...</h2>
                <p>Please wait while we validate event information.</p>
            </div>
        </div>

        <div v-else-if="initStatus === 'error'" class="app-status-wrap">
            <div class="app-status-card app-status-error">
                <h2>Unable to load event page</h2>
                <p>{{ initErrorMessage }}</p>
                <button class="retry-btn" @click="initializeSite">Retry</button>
            </div>
        </div>

        <router-view v-else />

    </div>

</template>

<script>

    export default {
        data() {
            return {
                initStatus: 'loading',
                initErrorMessage: ''
            }
        },
        created() {
            this.initializeSite();
        },
        computed: {
            getEventConfig() {
                return this.$store.getters.getEventConfig
            },
        },
        watch: {
            initStatus(value) {
                if (value === 'error') {
                    window.location.replace('https://www.grandchase.net/');
                }
            }
        },
        methods: {
            setErrorState(message) {
                this.initErrorMessage = message;
                this.initStatus = 'error';
            },
            async initializeSite() {
                this.initStatus = 'loading';
                this.initErrorMessage = '';

                try {
                    this.$store.dispatch('fetchEventConfig');

                    if (!Array.isArray(this.$store.state.evtGameServers) || this.$store.state.evtGameServers.length === 0) {
                        this.setErrorState('Event configuration is missing. Please check your .env values.');
                        return;
                    }

                    await this.fnPreCheckEventInfo();
                } catch (err) {
                    console.error(err);
                    this.setErrorState('Unexpected initialization error. Please retry in a moment.');
                }
            },
            fnPreCheckEventInfo() {
                let eventOptions = {
                    headers: { 'Content-Type': 'application/json' },
                    url: this.$store.state.evtApiServer + '/event/eventInfo?eventKey=' + this.$store.state.evtGameServers[0].eventKey,
                    method: 'get',
                }
                return this.$axios(eventOptions)
                    .then((res) => {
                        if (res.data.EventUID > 0) {
                            var _now = (new Date()).getTime();

                            this.$store.state.evtBase['EventUID'] = res.data.EventUID;
                            this.$store.state.evtBase['EventKey'] = res.data.EventKey;
                            this.$store.state.evtBase['SiteOpenTime'] = new Date(res.data.SiteOpenTime + 'Z');
                            this.$store.state.evtBase['SiteCloseTime'] = new Date(res.data.SiteCloseTime + 'Z');
                            this.$store.state.evtBase['RegStartTime'] = new Date(res.data.RegStartTime + 'Z');
                            this.$store.state.evtBase['RegEndTime'] = new Date(res.data.RegEndTime + 'Z');
                            this.$store.state.evtBase['ClientCountryCode'] = res.data.ClientCountryCode;
                            this.$store.state.evtBase['ClientIP'] = res.data.ClientIP;

                            console.log('SiteOpenTime : ' + this.$store.state.evtBase['SiteOpenTime']);
                     
                            if (this.$store.state.evtBase.SiteOpenTime.getTime() > _now || this.$store.state.evtBase.SiteCloseTime.getTime() < _now) {
                                // closed event
                                if (this.$store.state.isLiveServer == 'false') {
                                    alert(this.$store.state.errorCodes["evt-111"][this.$store.state.lang]);
                                    this.setErrorState('This event is currently closed.');
                                    return;
                                }
                                location.replace('https://www.grandchase.net/');
                            } else {
                                // opened event
                                this.initStatus = 'ready'
                            }

                            if (this.$store.state.evtBase.RegStartTime.getTime() <= _now && this.$store.state.evtBase.RegEndTime.getTime() >= _now) {
                                // to do 이벤트 폼 생성
                                this.$store.state.isForm = true
                            }

                        } else {
                            if (this.$store.state.isLiveServer == 'false') {
                                alert(this.$store.state.errorCodes["evt-110"][this.$store.state.lang]);
                                this.setErrorState('Event was not found on the API response.');
                            } else {
                                location.replace('https://www.grandchase.net/');
                            }


                        }
                    })
                    .catch((err) => {
                        console.error(`${err} (${err.status})\n\nMessage: ${err.responseText}`);
                        if (this.$store.state.isLiveServer == 'false') {
                            this.setErrorState('Failed to reach event API server. Please check network or API endpoint.');
                            return;
                        }
                        location.replace('https://www.grandchase.net/');
                    })
            },
        }
    }
</script>

<style lang="scss">
    @import './assets/scss/reset.scss';

    /* ===== 인터랙티브 효과 ===== */
    .reveal {
        opacity: 0;
        transform: translateY(40px);
        transition: opacity 0.8s ease, transform 0.8s cubic-bezier(0.22, 1, 0.36, 1);
        will-change: opacity, transform;
    }

    .reveal.is-visible {
        opacity: 1;
        transform: none;
    }

    /* 버튼: 살짝 떠오르며 골드 글로우, 클릭 시 눌림 */
    #btnRegsiter,
    #socialSubmitBtn,
    .gotoSite a,
    .preregClick button,
    .playnowBtn,
    .layer_popup a,
    .copyLink button {
        transition: transform 0.25s ease, box-shadow 0.25s ease, background 0.4s, color 0.4s !important;
    }

    #btnRegsiter:hover,
    #socialSubmitBtn:hover,
    .gotoSite a:hover,
    .preregClick button:hover,
    .playnowBtn:hover {
        transform: translateY(-3px);
        box-shadow: 0 10px 22px rgba(243, 218, 133, 0.35);
    }

    #btnRegsiter:active,
    #socialSubmitBtn:active,
    .gotoSite a:active,
    .preregClick button:active,
    .playnowBtn:active {
        transform: translateY(0) scale(0.98);
        box-shadow: none;
    }

    /* 하단 사전예약 버튼: 은은한 글로우 펄스 */
    .preregClick.isPrereg button {
        animation: preregPulse 2.4s ease-in-out infinite;
    }

    @keyframes preregPulse {
        0%, 100% { box-shadow: 0 0 0 0 rgba(243, 218, 133, 0); }
        50% { box-shadow: 0 0 22px 4px rgba(243, 218, 133, 0.45); }
    }

    /* 인게임 이벤트 슬라이드: 호버 시 이미지 확대 */
    .eventSlide .thumbBox {
        overflow: hidden;
    }

    .eventSlide .thumbBox img {
        transition: transform 0.5s ease;
    }

    .eventSlide .swiper-slide:hover .thumbBox img {
        transform: scale(1.05);
    }

    /* 입력 필드: 포커스 시 골드 테두리 + 글로우 */
    #app input[type="text"],
    #app select {
        transition: border-color 0.25s ease, box-shadow 0.25s ease;
    }

    #app input[type="text"]:focus,
    #app select:focus {
        outline: none;
        border-color: #f3da85 !important;
        box-shadow: 0 0 0 3px rgba(243, 218, 133, 0.35) !important;
    }

    /* 움직임 줄이기 설정을 켠 사용자는 효과 제거 */
    @media (prefers-reduced-motion: reduce) {
        .reveal {
            opacity: 1;
            transform: none;
            transition: none;
        }

        .preregClick.isPrereg button {
            animation: none;
        }

        #btnRegsiter:hover,
        #socialSubmitBtn:hover,
        .gotoSite a:hover,
        .preregClick button:hover,
        .playnowBtn:hover,
        .eventSlide .swiper-slide:hover .thumbBox img {
            transform: none;
        }
    }

    #app {
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        overflow: hidden;
        scroll-behavior: smooth;
        -webkit-user-drag: none;
        background: linear-gradient(to top,#1b2342,#1b2342);
        overflow: hidden;
    }

    .app-status-wrap {
        min-height: 100vh;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 24px;
    }

    .app-status-card {
        max-width: 560px;
        width: 100%;
        background: rgba(255, 255, 255, 0.08);
        border: 1px solid rgba(255, 255, 255, 0.18);
        border-radius: 12px;
        color: #f2f2f2;
        text-align: left;
        padding: 22px;

        h2 {
            margin: 0 0 12px;
            font-size: 24px;
            color: #ffffff;
        }

        p {
            margin: 0;
            font-size: 15px;
            line-height: 1.5;
            color: rgba(255, 255, 255, 0.9);
        }
    }

    .app-status-error {
        border-color: rgba(235, 96, 96, 0.75);
        background: rgba(90, 20, 20, 0.34);
    }

    .retry-btn {
        margin-top: 16px;
        border: none;
        border-radius: 8px;
        background: #ffffff;
        color: #1f1f1f;
        font-size: 14px;
        font-weight: 700;
        padding: 10px 18px;
        cursor: pointer;
    }

    nav {
      padding: 30px;
    }

    nav a {
      font-weight: bold;
      color: #2c3e50;
    }

    nav a.router-link-exact-active {
      color: #42b983;
    }
</style>
